<template>
  <v-btn icon><v-icon>mdi-bell</v-icon></v-btn>
</template>
<script>
export default {
  name: "ComBell",
  data: () => ({}),
};
</script>
